import AnalyticsDeals from './AnalyticsDeals.component';

export default AnalyticsDeals;